var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoNode(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 35 35",
    fill: "currentColor",
    height: "1em",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 23.95,
    y: 17.08,
    width: 7.25,
    height: 4.97,
    rx: 2.43,
    ry: 2.43
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.59,26.2l2.63-2.63h-2.35c-1.22,0-2.21-.99-2.21-2.22v-3.96c0-1.22.99-2.22,2.21-2.22h10.74l2.66-2.66h-6.9v-4.62c0-.53-.43-.96-.96-.96s-.96.43-.96.96v4.62h-4.58C2.19,12.52,0,14.71,0,17.39v3.96C0,23.95,2.04,26.05,4.59,26.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.12,12.52h-5.62l9.95-9.95c.45-.45.45-1.17,0-1.62-.45-.44-1.17-.45-1.62,0L.74,33.05c-.45.45-.45,1.17,0,1.62.22.22.52.33.81.33s.58-.11.81-.33l8.44-8.44h19.33c2.69,0,4.88-2.19,4.88-4.88v-3.96c0-2.69-2.19-4.87-4.88-4.87ZM32.34,21.36c0,1.22-.99,2.22-2.22,2.22H13.46l8.39-8.39h8.28c1.22,0,2.22.99,2.22,2.22v3.96Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoNode);
export default __webpack_public_path__ + "static/media/no_node.185dcaf82c5a312dc99df60328ded6b5.svg";
export { ForwardRef as ReactComponent };